import { MODAL_UPGRADE_PLAN } from '@components/App/Modal/constants'
import { Badge, Switch } from '@lib/components'
import { ProjectActions } from '@octopus-do/octopus-project-core'
import { Image as ImageIcon } from '@octopus-do/octopus-storybook/icons'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { commitProjectRequest } from '@storeOld/actionCreators'
import { openModal } from '@storeOld/reducers/ui'
import type React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useProjectAccess } from '@/hooks'
import { PROJECT_SETTINGS_PERMISSION } from '@/permissions/project/definitions'
import { clsJoin } from '@/utils'
import css from './styles.module.css'

type Props = {
  disabled?: boolean
}

export const ImageMode: React.FC<Props> = ({ disabled = false }) => {
  const dispatch = useDispatch()

  const imageModeToggle = useSelector(
    migrationProjectSelector.getProjectImagesMode
  )

  const { hasAccess, hasNotAvailableAccessBadge, badgeType } = useProjectAccess(
    PROJECT_SETTINGS_PERMISSION.ENABLE_IMAGES
  )

  const handleOnChange = (value: boolean) => {
    dispatch(
      commitProjectRequest(
        ProjectActions.settings.changeImageMode({ imageMode: value })
      )
    )
  }

  const handleBadgeClick = () => {
    dispatch(openModal(MODAL_UPGRADE_PLAN))
  }

  return (
    <div className={clsJoin(css.image_mod, !hasAccess && css.disabled)}>
      <ImageIcon />
      <div className={css.image_mod_text}>Images</div>

      <div className={css.image_mod_switch}>
        {!hasNotAvailableAccessBadge ? (
          <Switch
            mode="thin"
            checked={imageModeToggle}
            classes={{ container: css.switcher }}
            disabled={!hasAccess || disabled}
            onChange={handleOnChange}
          />
        ) : (
          <Badge type={badgeType} onClick={handleBadgeClick} />
        )}
      </div>
    </div>
  )
}
